import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderBillingAnalyticsComponentsByTypeKey: build.query<
      GetV2ProviderBillingAnalyticsComponentsByTypeKeyApiResponse,
      GetV2ProviderBillingAnalyticsComponentsByTypeKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/analytics/components/${queryArg.typeKey}`,
        params: {
          entity_id: queryArg.entityId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          as_of: queryArg.asOf,
          provider_ids: queryArg.providerIds,
          payer_ids: queryArg.payerIds,
          benchmark: queryArg.benchmark,
        },
      }),
    }),
    getV2ProviderBillingAnalyticsContainer: build.query<
      GetV2ProviderBillingAnalyticsContainerApiResponse,
      GetV2ProviderBillingAnalyticsContainerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/analytics/container`,
        params: {
          entity_id: queryArg.entityId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          as_of: queryArg.asOf,
          provider_ids: queryArg.providerIds,
          payer_ids: queryArg.payerIds,
          benchmark: queryArg.benchmark,
        },
      }),
    }),
    getV2ProviderBillingRevenueComponentsArAging: build.query<
      GetV2ProviderBillingRevenueComponentsArAgingApiResponse,
      GetV2ProviderBillingRevenueComponentsArAgingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/revenue/components/ar-aging`,
        params: {
          entity_id: queryArg.entityId,
        },
      }),
    }),
    getV2ProviderBillingRevenueComponentsCleanClaims: build.query<
      GetV2ProviderBillingRevenueComponentsCleanClaimsApiResponse,
      GetV2ProviderBillingRevenueComponentsCleanClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/revenue/components/clean-claims`,
        params: {
          entity_id: queryArg.entityId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          provider_id: queryArg.providerId,
          payer_name: queryArg.payerName,
          payer_id: queryArg.payerId,
          patient_offset: queryArg.patientOffset,
          patient_search: queryArg.patientSearch,
          patient_age_bucket: queryArg.patientAgeBucket,
          outcome: queryArg.outcome,
          lag_bucket: queryArg.lagBucket,
          age_bucket: queryArg.ageBucket,
          search: queryArg.search,
          offset: queryArg.offset,
          limit: queryArg.limit,
        },
      }),
    }),
    getV2ProviderBillingRevenueContainer: build.query<
      GetV2ProviderBillingRevenueContainerApiResponse,
      GetV2ProviderBillingRevenueContainerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/revenue/container`,
        params: {
          entity_id: queryArg.entityId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderBillingAnalyticsComponentsByTypeKeyApiResponse =
  /** status 200 OK */ ComponentResponse;
export type GetV2ProviderBillingAnalyticsComponentsByTypeKeyApiArg = {
  typeKey: string;
  /** Org id echoed from the FE for cache-keying; ignored for scoping. */
  entityId?: string | null;
  /** Window start (DOS axis). */
  dateFrom?: string | null;
  /** Window end (DOS axis). */
  dateTo?: string | null;
  /** A/R aging snapshot date. */
  asOf?: string | null;
  /** Clinician filter, CSV of provider ids. */
  providerIds?: string | null;
  /** Payer filter, CSV of payer ids. */
  payerIds?: string | null;
  /** Benchmark mode (industry|clinic). */
  benchmark?: string | null;
};
export type GetV2ProviderBillingAnalyticsContainerApiResponse =
  /** status 200 OK */ ContainerResponse;
export type GetV2ProviderBillingAnalyticsContainerApiArg = {
  /** Org id echoed from the FE for cache-keying; ignored for scoping. */
  entityId?: string | null;
  /** Window start (DOS axis). */
  dateFrom?: string | null;
  /** Window end (DOS axis). */
  dateTo?: string | null;
  /** A/R aging snapshot date. */
  asOf?: string | null;
  /** Clinician filter, CSV of provider ids. */
  providerIds?: string | null;
  /** Payer filter, CSV of payer ids. */
  payerIds?: string | null;
  /** Benchmark mode (industry|clinic). */
  benchmark?: string | null;
};
export type GetV2ProviderBillingRevenueComponentsArAgingApiResponse =
  /** status 200 OK */ ArAgingComponent;
export type GetV2ProviderBillingRevenueComponentsArAgingApiArg = {
  entityId?: string | null;
};
export type GetV2ProviderBillingRevenueComponentsCleanClaimsApiResponse =
  /** status 200 OK */ CleanClaimsComponent;
export type GetV2ProviderBillingRevenueComponentsCleanClaimsApiArg = {
  entityId?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  providerId?: string | null;
  payerName?: string | null;
  payerId?: string | null;
  patientOffset?: number;
  patientSearch?: string | null;
  patientAgeBucket?: number | null;
  outcome?: ("clean" | "denied" | "pending" | "other") | null;
  lagBucket?: number | null;
  ageBucket?: number | null;
  search?: string | null;
  offset?: number;
  limit?: number;
};
export type GetV2ProviderBillingRevenueContainerApiResponse =
  /** status 200 OK */ ContainerResponse;
export type GetV2ProviderBillingRevenueContainerApiArg = {
  entityId?: string | null;
};
export type ActionCardData = {
  cta_label: string;
  detail?: string | null;
  headline: string;
  primitive?: "action_card";
  variant?: string | null;
};
export type BannerData = {
  primitive?: "banner";
  severity: string;
  text: string;
};
export type ChartPoint = {
  x: string;
  y?: number | null;
};
export type ChartSeries = {
  name: string;
  points?: ChartPoint[];
};
export type ChartData = {
  goal_line?: number | null;
  markers?:
    | {
        [key: string]: any;
      }[]
    | null;
  primitive?: "chart";
  series: ChartSeries[];
  title?: string | null;
};
export type ClinicalChartAllergy = {
  allergen: string;
  allergy_id: string;
  date_added?: string | null;
  is_active?: boolean;
  onset_date?: string | null;
  reaction?: string | null;
  severity?: string | null;
};
export type ClinicalChartDiagnosis = {
  code?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  end_date?: string | null;
  is_active?: boolean;
  name: string;
  status: string;
};
export type ClinicalChartMedication = {
  date_prescribed?: string | null;
  dosage?: string | null;
  end_date?: string | null;
  form?: string | null;
  frequency?: string | null;
  generic_name?: string | null;
  indication?: string | null;
  is_active?: boolean;
  medication_id: string;
  name: string;
  route?: string | null;
  start_date?: string | null;
  status: string;
  strength?: string | null;
  timing?: string | null;
};
export type ClinicalChartData = {
  allergies?: ClinicalChartAllergy[];
  diagnoses?: ClinicalChartDiagnosis[];
  medications?: ClinicalChartMedication[];
  primitive?: "clinical_chart";
};
export type DomainPayloadData = {
  primitive?: "domain_payload";
  [key: string]: any;
};
export type KeyFact = {
  label: string;
  value: string;
};
export type HeaderData = {
  demographics?: string | null;
  key_facts?: KeyFact[];
  name: string;
  primitive?: "header";
};
export type ConsentEnvelope = {
  consent_stale?: boolean;
  consented_at?: string | null;
  state: "unavailable" | "needed" | "pulling" | "granted";
};
export type Action = {
  kind: "navigate" | "modal" | "chat_scope" | "dismiss" | "noop";
  label: string;
  payload?: {
    [key: string]: any;
  } | null;
  target?: string | null;
};
export type ItemListItem = {
  actions?: Action[];
  date?: string | null;
  detail?: string | null;
  label: string;
  status?: string | null;
  type?: string | null;
};
export type ItemListData = {
  consent?: ConsentEnvelope | null;
  filters?: string[] | null;
  items: ItemListItem[];
  page?: number | null;
  per_page?: number | null;
  primitive?: "item_list";
  total?: number | null;
};
export type KeyValueRow = {
  extra?: string | null;
  label: string;
  status?: string | null;
  value: string;
};
export type KeyValueGridData = {
  primitive?: "key_value_grid";
  rows: KeyValueRow[];
};
export type FeedbackConfig = {
  content_type: string;
  current_value?: ("positive" | "negative") | null;
};
export type Tag = {
  label: string;
  variant?: string | null;
};
export type TextBlockData = {
  actions?: Action[];
  body: string;
  feedback?: FeedbackConfig | null;
  primitive?: "text_block";
  subtitle?: string | null;
  tags?: Tag[] | null;
  title?: string | null;
};
export type TileAction = {
  action_key: string;
  label: string;
};
export type Tile = {
  actions?: TileAction[];
  chat_scope?: {
    [key: string]: any;
  } | null;
  detail?: string | null;
  feedback?: FeedbackConfig | null;
  headline: string;
  id: string;
  label?: string | null;
  signal_type?: string | null;
  tile_type?: string | null;
  variant: string;
};
export type TileRowData = {
  primitive?: "tile_row";
  tiles: Tile[];
};
export type ComponentResponse = {
  data?:
    | (
        | ({
            primitive: "action_card";
          } & ActionCardData)
        | ({
            primitive: "banner";
          } & BannerData)
        | ({
            primitive: "chart";
          } & ChartData)
        | ({
            primitive: "clinical_chart";
          } & ClinicalChartData)
        | ({
            primitive: "domain_payload";
          } & DomainPayloadData)
        | ({
            primitive: "header";
          } & HeaderData)
        | ({
            primitive: "item_list";
          } & ItemListData)
        | ({
            primitive: "key_value_grid";
          } & KeyValueGridData)
        | ({
            primitive: "text_block";
          } & TextBlockData)
        | ({
            primitive: "tile_row";
          } & TileRowData)
      )
    | null;
  delivery: "inline" | "lazy";
  endpoint?: string | null;
  placeholder?: {
    [key: string]: any;
  } | null;
  primitive:
    | "header"
    | "key_value_grid"
    | "clinical_chart"
    | "item_list"
    | "chart"
    | "text_block"
    | "tile_row"
    | "banner"
    | "action_card"
    | "domain_payload";
  type_key: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ActionCardData2 = {
  cta_label: string;
  detail?: string | null;
  headline: string;
  primitive?: "action_card";
  variant?: string | null;
};
export type BannerData2 = {
  primitive?: "banner";
  severity: string;
  text: string;
};
export type ChartPoint2 = {
  x: string;
  y?: number | null;
};
export type ChartSeries2 = {
  name: string;
  points?: ChartPoint2[];
};
export type ChartData2 = {
  goal_line?: number | null;
  markers?:
    | {
        [key: string]: any;
      }[]
    | null;
  primitive?: "chart";
  series: ChartSeries2[];
  title?: string | null;
};
export type ClinicalChartAllergy2 = {
  allergen: string;
  allergy_id: string;
  date_added?: string | null;
  is_active?: boolean;
  onset_date?: string | null;
  reaction?: string | null;
  severity?: string | null;
};
export type ClinicalChartDiagnosis2 = {
  code?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  end_date?: string | null;
  is_active?: boolean;
  name: string;
  status: string;
};
export type ClinicalChartMedication2 = {
  date_prescribed?: string | null;
  dosage?: string | null;
  end_date?: string | null;
  form?: string | null;
  frequency?: string | null;
  generic_name?: string | null;
  indication?: string | null;
  is_active?: boolean;
  medication_id: string;
  name: string;
  route?: string | null;
  start_date?: string | null;
  status: string;
  strength?: string | null;
  timing?: string | null;
};
export type ClinicalChartData2 = {
  allergies?: ClinicalChartAllergy2[];
  diagnoses?: ClinicalChartDiagnosis2[];
  medications?: ClinicalChartMedication2[];
  primitive?: "clinical_chart";
};
export type DomainPayloadData2 = {
  primitive?: "domain_payload";
  [key: string]: any;
};
export type KeyFact2 = {
  label: string;
  value: string;
};
export type HeaderData2 = {
  demographics?: string | null;
  key_facts?: KeyFact2[];
  name: string;
  primitive?: "header";
};
export type ConsentEnvelope2 = {
  consent_stale?: boolean;
  consented_at?: string | null;
  state: "unavailable" | "needed" | "pulling" | "granted";
};
export type Action2 = {
  kind: "navigate" | "modal" | "chat_scope" | "dismiss" | "noop";
  label: string;
  payload?: {
    [key: string]: any;
  } | null;
  target?: string | null;
};
export type ItemListItem2 = {
  actions?: Action2[];
  date?: string | null;
  detail?: string | null;
  label: string;
  status?: string | null;
  type?: string | null;
};
export type ItemListData2 = {
  consent?: ConsentEnvelope2 | null;
  filters?: string[] | null;
  items: ItemListItem2[];
  page?: number | null;
  per_page?: number | null;
  primitive?: "item_list";
  total?: number | null;
};
export type KeyValueRow2 = {
  extra?: string | null;
  label: string;
  status?: string | null;
  value: string;
};
export type KeyValueGridData2 = {
  primitive?: "key_value_grid";
  rows: KeyValueRow2[];
};
export type FeedbackConfig2 = {
  content_type: string;
  current_value?: ("positive" | "negative") | null;
};
export type Tag2 = {
  label: string;
  variant?: string | null;
};
export type TextBlockData2 = {
  actions?: Action2[];
  body: string;
  feedback?: FeedbackConfig2 | null;
  primitive?: "text_block";
  subtitle?: string | null;
  tags?: Tag2[] | null;
  title?: string | null;
};
export type TileAction2 = {
  action_key: string;
  label: string;
};
export type Tile2 = {
  actions?: TileAction2[];
  chat_scope?: {
    [key: string]: any;
  } | null;
  detail?: string | null;
  feedback?: FeedbackConfig2 | null;
  headline: string;
  id: string;
  label?: string | null;
  signal_type?: string | null;
  tile_type?: string | null;
  variant: string;
};
export type TileRowData2 = {
  primitive?: "tile_row";
  tiles: Tile2[];
};
export type ComponentResponse2 = {
  data?:
    | (
        | ({
            primitive: "action_card";
          } & ActionCardData2)
        | ({
            primitive: "banner";
          } & BannerData2)
        | ({
            primitive: "chart";
          } & ChartData2)
        | ({
            primitive: "clinical_chart";
          } & ClinicalChartData2)
        | ({
            primitive: "domain_payload";
          } & DomainPayloadData2)
        | ({
            primitive: "header";
          } & HeaderData2)
        | ({
            primitive: "item_list";
          } & ItemListData2)
        | ({
            primitive: "key_value_grid";
          } & KeyValueGridData2)
        | ({
            primitive: "text_block";
          } & TextBlockData2)
        | ({
            primitive: "tile_row";
          } & TileRowData2)
      )
    | null;
  delivery: "inline" | "lazy";
  endpoint?: string | null;
  placeholder?: {
    [key: string]: any;
  } | null;
  primitive:
    | "header"
    | "key_value_grid"
    | "clinical_chart"
    | "item_list"
    | "chart"
    | "text_block"
    | "tile_row"
    | "banner"
    | "action_card"
    | "domain_payload";
  type_key: string;
};
export type SectionResponse = {
  components: ComponentResponse2[];
  key: string;
  subtitle?: string | null;
  title: string;
};
export type ContainerResponse = {
  container_key: string;
  entity_id?: string | null;
  sections: SectionResponse[];
  stale?: boolean;
  top_level: ComponentResponse2[];
};
export type RevenueAgeCell = {
  balance_cents?: number;
  bucket: number;
  count?: number;
  label: string;
};
export type RevenueClaimRow = {
  age_days?: number | null;
  balance_cents: number;
  charge_cents: number;
  claim_id: string;
  lag_days?: number | null;
  outcome: "clean" | "denied" | "pending" | "other";
  patient_control_number?: string | null;
  patient_id?: string | null;
  payer_id?: string | null;
  payer_name: string;
  provider_name?: string | null;
  service_date?: string | null;
  status: string;
  submitted_date?: string | null;
};
export type RevenueClaimPage = {
  balance_cents?: number;
  limit?: number;
  offset?: number;
  rows?: RevenueClaimRow[];
  total?: number;
};
export type RevenueClinician = {
  display_name: string;
  provider_id: string;
};
export type RevenuePatientAccount = {
  account_id: string;
  age_days?: number | null;
  balance_cents: number;
  oldest_charge_date?: string | null;
};
export type RevenuePatientPage = {
  all_balance_cents?: number;
  all_count?: number;
  balance_cents?: number;
  buckets?: RevenueAgeCell[];
  limit?: number;
  offset?: number;
  over_90_cents?: number;
  over_90_count?: number;
  rows?: RevenuePatientAccount[];
  total?: number;
};
export type RevenuePayerAging = {
  balance_cents?: number;
  buckets?: RevenueAgeCell[];
  count?: number;
  payer_id?: string | null;
  payer_name: string;
};
export type ArAgingPayload = {
  as_of: string;
  balance_cents?: number;
  buckets?: RevenueAgeCell[];
  claim_count?: number;
  /** Retired claim drilldown. Always empty; use the claims queues. */
  claims: RevenueClaimPage;
  clinicians?: RevenueClinician[];
  definition?: string;
  over_90_cents?: number;
  over_90_count?: number;
  patient_scope?: string;
  /** Patient responsibility aggregates. Rows are always empty; account drilldowns are not provided by this component. */
  patients: RevenuePatientPage;
  payers?: RevenuePayerAging[];
  primitive?: "domain_payload";
  title?: string;
};
export type ArAgingComponent = {
  data: ArAgingPayload;
  delivery?: "inline";
  primitive?: "domain_payload";
  type_key?: "jotbill_ar_aging";
};
export type RevenueClaimRow2 = {
  age_days?: number | null;
  balance_cents: number;
  charge_cents: number;
  claim_id: string;
  lag_days?: number | null;
  outcome: "clean" | "denied" | "pending" | "other";
  patient_control_number?: string | null;
  patient_id?: string | null;
  payer_id?: string | null;
  payer_name: string;
  provider_name?: string | null;
  service_date?: string | null;
  status: string;
  submitted_date?: string | null;
};
export type RevenueClaimPage2 = {
  balance_cents?: number;
  limit?: number;
  offset?: number;
  rows?: RevenueClaimRow2[];
  total?: number;
};
export type RevenueClinician2 = {
  display_name: string;
  provider_id: string;
};
export type RevenueOutcomeCounts = {
  clean?: number;
  clean_rate_pct?: number | null;
  denied?: number;
  other?: number;
  pending?: number;
  responded?: number;
  submitted?: number;
};
export type RevenueLagBucket = {
  count: number;
  label: string;
};
export type RevenueLag = {
  buckets?: RevenueLagBucket[];
  eligible?: number;
  median_days?: number | null;
  p90_days?: number | null;
  within_3_days?: number;
};
export type RevenuePayerOutcome = {
  clean?: number;
  clean_rate_pct?: number | null;
  denied?: number;
  other?: number;
  payer_id?: string | null;
  payer_name: string;
  pending?: number;
  responded?: number;
  submitted?: number;
};
export type CleanClaimsPayload = {
  as_of: string;
  claims: RevenueClaimPage2;
  clinicians?: RevenueClinician2[];
  cohort_description?: string;
  counts: RevenueOutcomeCounts;
  date_from: string;
  date_to: string;
  definition?: string;
  lag: RevenueLag;
  payers?: RevenuePayerOutcome[];
  primitive?: "domain_payload";
  title?: string;
};
export type CleanClaimsComponent = {
  data: CleanClaimsPayload;
  delivery?: "inline";
  primitive?: "domain_payload";
  type_key?: "jotbill_clean_claims";
};
